/**
 * SA-476 (spec D4): "a" or "an" before a word the page does not know in
 * advance — a pack's record noun ("Quote", "Order"), a humanized agenda id.
 * By the first LETTER, not the sound: "an Unit" and "a Hour" read wrong, and
 * that is accepted — the words are pack nouns and ids, and no shipped one
 * hits it.
 */
export function indefiniteArticle(word: string, opts: { capital?: boolean } = {}): 'a' | 'an' | 'A' | 'An' {
  const an = /^[aeiou]/i.test(word.trim())
  if (opts.capital) return an ? 'An' : 'A'
  return an ? 'an' : 'a'
}
